import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk for fetching student statistics
export const fetchStudentStatistics = createAsyncThunk(
  'studentStatistics/fetchStats',
  async (childId = null, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) throw new Error("No authentication token found");

      // Build URL based on whether childId is provided
      let url = `${BASE_URL}/student_statistics`;
      if (childId) {
        url += `?child_id=${childId}`;
      }

      const response = await axios.get(url, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      });

      const data = response.data;

      if (data.status === "success") {
        return data.result;
      } else {
        return rejectWithValue(data.message || "حدث خطأ في جلب إحصائيات الطالب");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.message || "حدث خطأ في جلب إحصائيات الطالب");
      } else if (error.message && error.message.toLowerCase().includes("network")) {
        return rejectWithValue("حدث خطأ في الاتصال بالخادم");
      } else {
        return rejectWithValue(error.message || "حدث خطأ غير متوقع");
      }
    }
  }
);

const initialState = {
  statistics: null,
  loading: false,
  error: null,
  selectedChildId: null
};

const studentStatisticsSlice = createSlice({
  name: 'studentStatistics',
  initialState,
  reducers: {
    clearStatisticsError: (state) => {
      state.error = null;
    },
    setSelectedChildId: (state, action) => {
      state.selectedChildId = action.payload;
    },
    clearStatistics: (state) => {
      state.statistics = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentStatistics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentStatistics.fulfilled, (state, action) => {
        state.loading = false;
        state.statistics = action.payload;
        state.error = null;
      })
      .addCase(fetchStudentStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearStatisticsError, setSelectedChildId, clearStatistics } = studentStatisticsSlice.actions;
export default studentStatisticsSlice.reducer;
